module.exports = __webpack_public_path__ + "img/addon-is.471c850f.jpg";